"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _theme = _interopRequireDefault(require("../theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
Create media queries using the breakpoints defined in the theme.

EXAMPLE 1: STRING STYLE
const Testing = styled.div`
  background-color: red;
  ${mediaQuery('l')} { background-color: blue; }
`;

EXAMPLE 2: OBJECT STYLE
const Testing = styled.div({
  backgroundColor: 'red',
  [mediaQuery('l')]: { backgroundColor: 'blue' },
});
 */

var breakPoint = function breakPoint(bp) {
  return "@media (min-width: ".concat(_theme["default"].breakpoints[bp], ")");
};
var _default = breakPoint;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJicmVha1BvaW50IiwiYnAiLCJ0aGVtZSIsImJyZWFrcG9pbnRzIl0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hlbHBlcnMvbWVkaWFRdWVyeS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdGhlbWUgZnJvbSAnLi4vdGhlbWUnO1xuaW1wb3J0IHsgQnJlYWtwb2ludHNBbGlhc1R5cGUgfSBmcm9tICcuLi90eXBlcy90aGVtZSc7XG5cbi8qXG5DcmVhdGUgbWVkaWEgcXVlcmllcyB1c2luZyB0aGUgYnJlYWtwb2ludHMgZGVmaW5lZCBpbiB0aGUgdGhlbWUuXG5cbkVYQU1QTEUgMTogU1RSSU5HIFNUWUxFXG5jb25zdCBUZXN0aW5nID0gc3R5bGVkLmRpdmBcbiAgYmFja2dyb3VuZC1jb2xvcjogcmVkO1xuICAke21lZGlhUXVlcnkoJ2wnKX0geyBiYWNrZ3JvdW5kLWNvbG9yOiBibHVlOyB9XG5gO1xuXG5FWEFNUExFIDI6IE9CSkVDVCBTVFlMRVxuY29uc3QgVGVzdGluZyA9IHN0eWxlZC5kaXYoe1xuICBiYWNrZ3JvdW5kQ29sb3I6ICdyZWQnLFxuICBbbWVkaWFRdWVyeSgnbCcpXTogeyBiYWNrZ3JvdW5kQ29sb3I6ICdibHVlJyB9LFxufSk7XG4gKi9cblxuY29uc3QgYnJlYWtQb2ludCA9IChicDogQnJlYWtwb2ludHNBbGlhc1R5cGUpOiBzdHJpbmcgPT5cbiAgYEBtZWRpYSAobWluLXdpZHRoOiAke3RoZW1lLmJyZWFrcG9pbnRzW2JwXX0pYDtcblxuZXhwb3J0IGRlZmF1bHQgYnJlYWtQb2ludDtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7QUFBNkI7QUFHN0I7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBOztBQUVBLElBQU1BLFVBQVUsR0FBRyxTQUFiQSxVQUFVLENBQUlDLEVBQXdCO0VBQUEsb0NBQ3BCQyxpQkFBSyxDQUFDQyxXQUFXLENBQUNGLEVBQUUsQ0FBQztBQUFBLENBQUc7QUFBQyxlQUVsQ0QsVUFBVTtBQUFBIn0=